export default __webpack_public_path__ + "static/1236-fc1fa096d743b39dde24b14c317a933f.gif";